export default __webpack_public_path__ + "static/media/9.197fd23f.jpg";